<template>
  <section>
    <div class="content-wrapper">
      <errors v-if="isVisibleErrorsModal"></errors>
      <question v-if="display"></question>
      <checkwire v-if="isCheckWireModalVisible" :closeAction="loadFundingSourceAfterModalSave"></checkwire>
      <div class="content-heading">
        Account
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <breadcrumb class="breadcrumb" v-bind:breadcrumbsData="breadcrumbData" />
      <br>

      <div class="row">
        <spinner v-if="userDetailLoading || accountUsersLoading || noteLoading || fundingLoading"></spinner>
        <div class="col-xs-12">
          <div id="panelChart9" class="panel panel-default">

          <div class="panel-title top-margin">
            {{user.firstName}} {{user.lastName}} - {{getAccountType()}}
          </div>
          <div class="line-separator"></div>
              <div class="info-row">
                <div class="info-label">
                  <label>Id:</label>
                </div>
                <div class="info-value">
                  <p> {{account.accountId}} </p>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <label>Date created:</label>
                </div>
                <div class="info-value">
                  <p> {{formatDate(account.createdAt)}} </p>
                </div>
              </div>
              <div class="info-row" v-if="account.investorSince">
                <div class="info-label">
                  <label>Investor since:</label>
                </div>
                <div class="info-value">
                  <p> {{account.investorSince}} </p>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <label>Status:</label>
                </div>
                <div class="info-value">
                  <div class="space-between">
                    <p v-if="account.status == 'active'" class="label label-success capitalize-text"> {{account.status}} </p>
                    <p v-if="account.status == 'pending'" class="label label-warning capitalize-text"> {{account.status}} </p>
                    <p v-if="account.status == 'inactive'" class="label label-danger capitalize-text"> {{account.status}} </p>
                    <p v-if="account.hasUserComments" class="label label-danger capitalize-text"> Comments </p>
                  </div>
                </div>
              </div>

            <div class="panel-subtitle top-margin">
              Authorized account holders and representatives
            </div>
            <div class="line-separator"></div>
              <div class="representatives-section">
                <p class="label-names">Name:</p>
                <div class="representatives-list">
                  <p v-for="(representative, index) in accountRepresentatives" :key="index">
                    {{representative.fullName}}
                  </p>
                </div>
              </div>

            <div class="panel-title">
              Note list
            </div>
            <div class="line-separator"></div>
            <button type="button" class="btn btn-default btn-lg btn-full-mobile top-margin" v-on:click="goToPurchaseInvestmentNote()">
              Make an investment
            </button>
            <div class="balance-section">
                <span class="panel-subtitle">Current account balance: <strong class="amountBalance">{{formatAmount(currentAmountBalance)}}</strong></span>
              </div>
            <div class="panel-subtitle top-margin bottom-margin">
                Notes list
            </div>
            <div v-if="notes.length === 0" class="panel-body">
               <div class="alert alert-info alert-dismissible" role="alert">
                   No notes found.
                </div>
            </div>
            
            <div v-if="notes.length > 0" class="notes-container">
              <div class="notes-table-desktop" v-bind:class="{'table-fixed-header--md cols-9': notes.length > 6}">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-center">Note number</th>
                      <th class="text-center">Term</th>
                      <th class="text-center">Rate</th>
                      <th class="text-right">Principal amount</th>
                      <th class="text-center">Purchase date</th>
                      <th class="text-center">Open date</th>
                      <th class="text-center">Maturity date</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">View details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(note, index) in notes" :key="index">
                      <td class="text-center">{{note.noteId}}</td>
                      <td class="text-center">{{formatTerm(note.interestTerm)}}</td>
                      <td class="text-center">{{formatRate(note.interestRate)}}</td>
                      <td class="text-right">{{formatAmount(note.currentBalance)}}</td>
                      <td class="text-center">{{formatDate(note.purchasedOn)}}</td>
                      <td class="text-center">{{formatDate(note.openedOn)}}</td>
                      <td class="text-center">{{formatDate(note.maturityDate)}}</td>
                      <td class="text-center">
                        <span class="label label-danger" v-if="note.status == 'cancelled'">Cancelled</span>
                        <span class="label label-danger" v-if="note.status == 'failed'">Failed</span>
                        <span class="label label-danger" v-if="note.status == 'closed'">Closed</span>
                        <span class="label label-warning" v-if="note.status == 'pending'">Pending</span>
                        <span class="label label-success" v-if="note.status == 'open'">Open</span>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-details btn-outline" v-on:click="goToViewDetail(note)">View details</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div class="notes-cards-mobile">
                <div v-for="(note, index) in notes" :key="index" class="note-card">
                  <div class="note-card-header">
                    <div class="note-card-title">Note #{{note.noteId}}</div>
                    <span class="label label-danger" v-if="note.status == 'cancelled'">Cancelled</span>
                    <span class="label label-danger" v-if="note.status == 'failed'">Failed</span>
                    <span class="label label-danger" v-if="note.status == 'closed'">Closed</span>
                    <span class="label label-warning" v-if="note.status == 'pending'">Pending</span>
                    <span class="label label-success" v-if="note.status == 'open'">Open</span>
                  </div>
                  <div class="note-card-body">
                    <div class="note-card-row">
                      <span class="note-card-label">Term:</span>
                      <span class="note-card-value">{{formatTerm(note.interestTerm)}}</span>
                    </div>
                    <div class="note-card-row">
                      <span class="note-card-label">Rate:</span>
                      <span class="note-card-value">{{formatRate(note.interestRate)}}</span>
                    </div>
                    <div class="note-card-row">
                      <span class="note-card-label">Principal amount:</span>
                      <span class="note-card-value">{{formatAmount(note.currentBalance)}}</span>
                    </div>
                    <div class="note-card-row">
                      <span class="note-card-label">Purchase date:</span>
                      <span class="note-card-value">{{formatDate(note.purchasedOn)}}</span>
                    </div>
                    <div class="note-card-row">
                      <span class="note-card-label">Open date:</span>
                      <span class="note-card-value">{{formatDate(note.openedOn)}}</span>
                    </div>
                    <div class="note-card-row">
                      <span class="note-card-label">Maturity date:</span>
                      <span class="note-card-value">{{formatDate(note.maturityDate)}}</span>
                    </div>
                  </div>
                  <div class="note-card-footer">
                    <button type="button" class="btn btn-details btn-outline btn-block" v-on:click="goToViewDetail(note)">View details</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="space"></div>
            <div class="panel-title top-margin">
              Bank account
            </div>
            <div class="line-separator"></div>
            <div class="action-button-container">
              <button type="submit" v-on:click="openCheckWireModal()" class="btn btn-default btn-lg btn-full-mobile">Add check or wire transfer</button>
            </div>
            <div class="panel-subtitle top-margin bottom-margin">
            Account list
            </div>
            <div v-if="fundingSources.length === 0" class="panel-body">
               <div class="alert alert-info alert-dismissible" role="alert">
                   No bank accounts were found.
                </div>
            </div>
            
            <div v-if="fundingSources.length > 0" class="funding-container">
              <div class="funding-table-desktop" v-bind:class="{'table-fixed-header--sm cols-5': fundingSources.length > 3}">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-center">Bank name</th>
                      <th class="text-center">Account name</th>
                      <th class="text-center">Type</th>
                      <th class="text-center">Default</th>
                      <th class="text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(funding, index) in fundingSources" :key="index">
                      <td class="text-center">{{funding.bankName ? funding.bankName : '-----'}}</td>
                      <td class="text-center">{{funding.name}}</td>
                      <td class="text-center">{{formatType(funding.type, 'investor')}}</td>
                      <td class="text-center">
                          <input v-if="funding.status === 'verified'" type="radio" v-bind:value="funding.id"
                          v-model="userAccount.defaultFundingSourceId"
                          @change="showDefaultFundingSourceConfirmationModal({ fundingSource: funding })" />
                      </td>
                      <td class="text-center">
                        <span class="label" v-if="funding.type !== 'check' && funding.type!=='wire-transfer'" v-bind:class="funding.status === 'verified' ? 'label-success' : 'label-warning'">
                          {{funding.status}}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div class="funding-cards-mobile">
                <div v-for="(funding, index) in fundingSources" :key="index" class="funding-card">
                  <div class="funding-card-header">
                    <div class="funding-card-title">{{funding.name}}</div>
                    <span class="label" v-if="funding.type !== 'check' && funding.type!=='wire-transfer'" v-bind:class="funding.status === 'verified' ? 'label-success' : 'label-warning'">
                      {{funding.status}}
                    </span>
                  </div>
                  <div class="funding-card-body">
                    <div class="funding-card-row">
                      <span class="funding-card-label">Bank name:</span>
                      <span class="funding-card-value">{{funding.bankName ? funding.bankName : '-----'}}</span>
                    </div>
                    <div class="funding-card-row">
                      <span class="funding-card-label">Type:</span>
                      <span class="funding-card-value">{{formatType(funding.type, 'investor')}}</span>
                    </div>
                    <div class="funding-card-row" v-if="funding.status === 'verified'">
                      <span class="funding-card-label">Default:</span>
                      <span class="funding-card-value">
                        <input type="radio" v-bind:value="funding.id"
                        v-model="userAccount.defaultFundingSourceId"
                        @change="showDefaultFundingSourceConfirmationModal({ fundingSource: funding })" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="space"></div>
            <div class="panel-title top-margin">
              Account preference
            </div>
            <div class="line-separator"></div>
            <div class="preferences-container">
              <div class="preference-item">
                <div v-bind:class="account.paymentPreference === 'reinvest' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input id="ritema" name="ritem" type="radio" v-bind:value="'reinvest'"
                    v-model="account.paymentPreference" @change="showConfirmationModal('reinvest')"/>
                  <label for="ritema">{{formatPaymentPreference('reinvest')}}</label>
                </div>
              </div>
              <div class="preference-item">
                <div v-bind:class="account.paymentPreference === 'payout' ? 'radio-item radio-item-repay' : 'radio-item radio-item-repay radio-item-unselected'">
                  <input id="ritemb" name="ritem" type="radio" v-bind:value="'payout'"
                    v-model="account.paymentPreference" @change="showConfirmationModal('payout')"/>
                  <label for="ritemb">{{formatPaymentPreference('payout')}}</label>
                </div>
              </div>
              <div class="preference-item">
                <div v-bind:class="account.paymentPreference === 'donate' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input id="ritemc" name="ritem" type="radio" v-bind:value="'donate'"
                    v-model="account.paymentPreference" @change="showConfirmationModal('donate')"/>
                  <label for="ritemc">{{formatPaymentPreference('donate')}}</label>
                </div>
              </div>
            </div>

            <div class="space"></div>
            <div class="line-separator"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';

  import Errors from '@/components/modals/Errors';
  import Question from '@/components/modals/Question';
  import CheckWire from '@/components/modals/CheckWireTransfer';
  import breadcrumb from '@/components/Breadcrumb';
  import _ from 'lodash';

  import {
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
    SHOW_QUESTION_MODAL,
    HIDE_QUESTION_MODAL,
    SHOW_CHECK_WIRE_MODAL,
    SET_CREATION_SUCCEEDED,
  } from '@/store/mutation-types';

  import { formatDate, formatAmount, formatRate, formatTerm, formatType, formatPaymentPreference, findAccount } from '@/util';
  import spinner from '@/components/widgets/Spinner';
  import { UserTypes } from '@/data/static/userTypes';

  import {
    Constants,
  } from '../data/static/constants';

  const mix = {
    methods: {
      formatDate,
      formatAmount,
      formatRate,
      formatTerm,
      formatType,
      formatPaymentPreference,
      findAccount,
    },
  };

  export default {
    name: 'accountDetail',
    beforeMount() {
      this.setParams();
      this.loadUserDetail();
      this.loadNotesList();
      this.loadAccountUsers();
      this.loadFundingSources();
    },
    mixins: [mix],
    components: {
      errors: Errors,
      question: Question,
      checkwire: CheckWire,
      spinner,
      breadcrumb,
    },
    watch: {
      user: function changedUser(newUser) {
        this.breadcrumbData = [];
        this.breadcrumbData.push(
          Object.assign({}, {
            title: 'Search',
            goto: { name: 'Users' },
            selected: false,
          }),
        );
        const params = Object.assign({}, this.$route.params);
        let goto;
        if (newUser.userType === UserTypes.FINANCIAL_ADVISOR.name) {
          goto = { name: 'EditFinancialAdvisor', params: { name: params.name, userId: params.userId } };
        } else {
          goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
        }
        const title = newUser.firstName.concat(' ', newUser.lastName);
        this.breadcrumbData.push(
          Object.assign({}, {
            title,
            goto,
            selected: false,
          }),
        );
        const gotoAccount = { name: this.$route.name, params };
        this.breadcrumbData.push(
          Object.assign({}, {
            title: this.userAccount.accountName,
            goto: gotoAccount,
            selected: true,
          }),
        );
      },
    },
    data() {
      return {
        userId: '',
        accountId: '',
        name: '',
        breadcrumbData: [],
        user: [],
        userAccount: {
          defaultFundingSourceId: '',
        },
        notes: [],
        account: {},
        fundingSources: [],
        currentAmountBalance: 0,
        maxAmountFundingSources: 6,
        previousFundingSourceId: '',
        previousPaymentPreference: '',
        notesError: '',
        noteLoading: false,
        fundingLoading: false,
        userDetailLoading: false,
        accountUsersLoading: false,
        accountRepresentatives: [],
        beneficiaries: [],
      };
    },
    computed: {
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('home', [
        'userStatus',
      ]),
      ...mapState('question', [
        'display',
      ]),
      ...mapState('checkWireModal', [
        'isCheckWireModalVisible',
        'creationSucceeded',
      ]),
    },
    methods: {
      ...mapActions('account', [
        'getAccount',
        'getAccountUsers',
        'getAccountNotes',
        'getAccountFundingSources',
        'updateAccountPaymentPreference',
        'setDefaultFundingSource',
        'getAccountBeneficiaries',
      ]),
      ...mapActions('accountCreation', [
        'getUserDetail',
      ]),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      ...mapMutations('checkWireModal', {
        showCheckWireModal: SHOW_CHECK_WIRE_MODAL,
        setCreationStatus: SET_CREATION_SUCCEEDED,
      }),
      setParams() {
        this.userId = this.$route.params.userId;
        this.accountId = this.$route.params.accountId;
        this.name = this.$route.params.name;
      },
      loadUserDetail() {
        this.userDetailLoading = true;
        return this.getUserDetail(this.userId).then((user) => {
          this.userDetailLoading = false;
          this.user = user;
          this.userAccount = this.findAccount(user.accounts, this.accountId);
          this.previousFundingSourceId = this.userAccount.defaultFundingSourceId;
        }).catch((err) => {
          this.userDetailLoading = false;
          if (err !== 'UNAUTHORIZED') {
            this.setErrorsModalInfo(['We could not retrieve user detail']);
            this.showErrorsModal();
          }
        });
      },
      async loadAccountUsers() {
        try {
          this.accountUsersLoading = true;
          const [account, accountRepresentatives] = await Promise.all([
            this.getAccount(this.accountId),
            this.getAccountUsers(this.accountId),
          ]);
          this.accountRepresentatives = accountRepresentatives;
          this.account = account;
          this.previousPaymentPreference = this.account.paymentPreference;
          return Promise.resolve({});
        } catch (err) {
          if (err !== 'UNAUTHORIZED') {
            this.setErrorsModalInfo(['We could not retrieve users list']);
            this.showErrorsModal();
            return err;
          }
          return Promise.reject(err);
        } finally {
          this.accountUsersLoading = false;
        }
      },
      loadNotesList() {
        this.noteLoading = true;
        return this.getAccountNotes(this.accountId)
        .then((notes) => {
          this.noteLoading = false;
          this.notes = notes;
          const openNotes = _.filter(notes, { status: 'open' });
          this.currentAmountBalance = _.sumBy(['currentBalance'], _.partial(_.sumBy, openNotes));
        })
        .catch((err) => {
          this.noteLoading = false;
          if (err !== 'UNAUTHORIZED') {
            this.setErrorsModalInfo(['We could not retrieve notes list']);
            this.showErrorsModal();
          }
        });
      },
      loadFundingSourceAfterModalSave() {
        if (this.creationSucceeded) {
          this.loadUserDetail();
          this.loadFundingSources();
          this.setCreationStatus(false);
        }
      },
      loadFundingSources() {
        this.fundingLoading = true;
        return this.getAccountFundingSources(this.accountId)
        .then((data) => {
          this.fundingLoading = false;
          this.fundingSources = data.filter(fss => !fss.removed &&
          (fss.type === 'bank' ||
          fss.type === 'check' ||
          fss.type === 'wire/ach'));
        }).catch((err) => {
          this.fundingLoading = false;
          if (err !== 'UNAUTHORIZED') {
            this.setErrorsModalInfo(['We could not retrieve bank accounts list']);
            this.showErrorsModal();
          }
        });
      },
      getAccountType() {
        if (this.userAccount && this.userAccount.accountType) {
          const accountType = this.userAccount.accountType;
          return `${accountType[0]}${accountType.slice(1).toLowerCase()}`;
        }
        return '';
      },
      getAccountBeneficiariesDetails() {
        this.getAccountBeneficiaries(this.accountId).then((beneficiaries) => {
          this.beneficiaries = beneficiaries;
        });
      },
      showDefaultFundingSourceConfirmationModal({
        fundingSource,
      }) {
        this.userAccount.defaultFundingSourceId = this.previousFundingSourceId;
        this.showQuestionModal({
          title: 'Bank account',
          question: `Are you sure you want to select ${fundingSource.name} as new default bank account?`,
          method: () => {
            this.methodToExecuteInDefaultFundingSourceQuestionModal(fundingSource.id);
          },
          yesButtonText: Constants.purchaseNote.modalYesButtonText,
          hideCancelButton: false,
        });
      },
      showConfirmationModal(paymentPreference) {
        this.account.paymentPreference = this.previousPaymentPreference;
        this.showQuestionModal({
          title: Constants.accountDetail.modalTitle,
          question: `Are you sure you want to select ${this.formatPaymentPreference(paymentPreference)} as your new default payment action?`,
          method: () => {
            this.methodToExecuteInQuestionModal(paymentPreference);
          },
          yesButtonText: Constants.accountDetail.modalYesButtonText,
          hideCancelButton: false,
        });
      },
      methodToExecuteInDefaultFundingSourceQuestionModal(fundingSourceId) {
        this.hideQuestionModal();
        const account = this.userAccount;
        this.setDefaultFundingSource({
          accountId: account.id,
          fundingSourceId,
        }).then(() => {
          this.previousFundingSourceId = fundingSourceId;
          this.userAccount.defaultFundingSourceId = fundingSourceId;
        });
      },
      methodToExecuteInQuestionModal(paymentPreference) {
        this.hideQuestionModal();
        this.updateAccountPaymentPreference({
          accountId: this.accountId,
          paymentPreference,
        }).then(() => {
          this.previousPaymentPreference = paymentPreference;
          this.account.paymentPreference = paymentPreference;
        });
      },
      openCheckWireModal() {
        const filteredFundingSources = this.fundingSources.filter(fss => fss.type === 'check' ||
          fss.type === 'wire-transfer');
        this.showCheckWireModal({ accountId: this.accountId,
          fundingSources: filteredFundingSources });
      },
      goToPurchaseInvestmentNote() {
        const accountId = this.accountId;
        const userId = this.userId;
        const name = this.name;
        this.$router.push({ name: 'PurchaseInvestmentNote', params: { accountId, userId, name } });
      },
      goToViewDetail(note) {
        const userId = this.userId;
        const name = this.name;

        const noteObj = Object.assign({}, note);
        const routeParams = { name: 'NoteDetail', params: { name, userId, noteId: noteObj.id } };
        this.$router.push(routeParams);
      },
    },
  };
</script>

<style scoped>
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .left-margin {
    margin-left: 2%;
  }
  .right-margin {
    margin-left: -4%;
  }
  .top-margin {
    margin-top: 2%;
  }
  .bottom-margin {
    margin-bottom: 1%;
  }
  .space {
    margin-top: 4%;
  }
  .content-heading {
    font-weight: normal;
  }
  .panel-title {
    font-size: 20px;
  }
  .panel-subtitle {
    font-size: 16px;
  }
  .panel-default {
    padding: 30px 40px;
  }
  .panel-heading {
    background-color: #ffffff;
    font-size: 16px;
    padding: 0px 5px;
  }
  label {
    color: #888;
    font-size: 14px;
    width: auto;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  table {
    border-collapse: collapse;
  }
  th {
    padding: 14px 8px;
    color: #888;
    border-bottom-width: 1px;
    vertical-align: bottom;
    border-bottom: 1px solid #eee;
    border-top: 0;
    line-height: 1.52857143;
    font-weight: normal;
  }
  td {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #fafbfc;
  }
  .amountBalance {
    font-size: 20px;
  }
  .label-name {
    color: #31b0d5;
  }
  .label-names {
    font-size: 20px;
  }
  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    padding-left: 20px;
  }
  .icon-back {
    position:relative;
  }
  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position:absolute;
    left: 0px;
  }
  .button-check-wire {
    background-color: white;
    border-color: #127285;
    color: #127285;
  }
  .checkbox + .checkbox {
    margin-top: 20px;
  }
   .checkbox {
    cursor: default;
  }
   .checkbox label {
    position: relative;
    padding-left: 40px;
    cursor: pointer;
    color: #211915;
    width: auto;
    text-overflow: inherit;
    overflow: initial;
    white-space: initial;
  }
   .c-checkbox:hover span {
    border-color: #cccccc;
  }
   .c-checkbox label:hover span {
    border-color: #137D8F;
  }
   .checkbox .fa-check {
    position: absolute;
    margin: 0;
    left: 0;
  }
   .checkbox-disabled {
   outline:1px solid red;
  }
   .checkbox p {
    margin-left: 40px;
    display: inline-block;
    cursor: text;
    color: #929292;
  }
   .checkbox-link {
    margin-left: 4px;
    display: inline-block;
    color: #137D8F;
    opacity: .75;
    transition: color .4s ease-in-out;
  }
   .checkbox-link:hover {
    opacity: 1;
  }
  .radio-item label {
    color: #666;
    font-weight: normal;
    padding-left: 25px;
    padding-top: 5px;
    cursor: pointer;
    overflow: visible;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: absolute;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }
  .radio-item input[type=radio]:checked+label:after {
    border-radius: 5px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 4.85px;
    right: auto;
    margin: auto;
    content: "";
    display: block;
  }
  .capitalize-text {
    text-transform: capitalize;
  }
  .space-between {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  /* Info rows for account details */
  .info-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    align-items: flex-start;
  }
  .info-label {
    flex: 0 0 auto;
    min-width: 120px;
  }
  .info-value {
    flex: 1;
  }
  .info-value p {
    margin: 0;
  }

  /* Representatives section */
  .representatives-section {
    margin-left: 2%;
  }
  .representatives-list {
    margin-top: 8px;
  }
  .representatives-list p {
    margin: 4px 0;
  }

  /* Balance section */
  .balance-section {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  /* Action button container */
  .action-button-container {
    margin-top: 16px;
  }

  /* Notes table/cards container */
  .notes-container {
    margin-bottom: 16px;
  }
  .notes-cards-mobile {
    display: none;
  }
  .notes-table-desktop {
    display: block;
  }

  /* Note cards for mobile */
  .note-card {
    border: 1px solid #eee;
    border-radius: 4px;
    margin-bottom: 16px;
    background-color: #fff;
    overflow: hidden;
  }
  .note-card-header {
    padding: 12px 16px;
    background-color: #fafbfc;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .note-card-title {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }
  .note-card-body {
    padding: 12px 16px;
  }
  .note-card-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #f5f5f5;
  }
  .note-card-row:last-child {
    border-bottom: none;
  }
  .note-card-label {
    color: #888;
    font-size: 14px;
    font-weight: 500;
  }
  .note-card-value {
    color: #333;
    font-size: 14px;
    text-align: right;
  }
  .note-card-footer {
    padding: 12px 16px;
    background-color: #fafbfc;
    border-top: 1px solid #eee;
  }

  /* Funding table/cards container */
  .funding-container {
    margin-bottom: 16px;
  }
  .funding-cards-mobile {
    display: none;
  }
  .funding-table-desktop {
    display: block;
  }

  /* Funding cards for mobile */
  .funding-card {
    border: 1px solid #eee;
    border-radius: 4px;
    margin-bottom: 16px;
    background-color: #fff;
    overflow: hidden;
  }
  .funding-card-header {
    padding: 12px 16px;
    background-color: #fafbfc;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .funding-card-title {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }
  .funding-card-body {
    padding: 12px 16px;
  }
  .funding-card-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #f5f5f5;
    align-items: center;
  }
  .funding-card-row:last-child {
    border-bottom: none;
  }
  .funding-card-label {
    color: #888;
    font-size: 14px;
    font-weight: 500;
  }
  .funding-card-value {
    color: #333;
    font-size: 14px;
  }

  /* Preferences container */
  .preferences-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 16px;
  }
  .preference-item {
    flex: 1;
    min-width: 200px;
  }

  /* Mobile responsive styles */
  @media (max-width: 768px) {
    .panel-default {
      padding: 20px 16px;
    }

    .content-heading {
      font-size: 24px;
    }

    .panel-title {
      font-size: 18px;
    }

    .panel-subtitle {
      font-size: 15px;
    }

    .info-row {
      flex-direction: column;
      margin-bottom: 16px;
    }

    .info-label {
      min-width: auto;
      margin-bottom: 4px;
    }

    .info-label label {
      font-weight: 500;
    }

    .representatives-section {
      margin-left: 0;
    }

    .balance-section {
      text-align: center;
    }

    .amountBalance {
      font-size: 18px;
    }

    .btn-full-mobile {
      width: 100%;
    }

    /* Hide desktop table, show mobile cards for notes */
    .notes-table-desktop {
      display: none;
    }
    .notes-cards-mobile {
      display: block;
    }

    /* Hide desktop table, show mobile cards for funding */
    .funding-table-desktop {
      display: none;
    }
    .funding-cards-mobile {
      display: block;
    }

    /* Make preferences stack on mobile */
    .preferences-container {
      flex-direction: column;
      gap: 12px;
    }
    .preference-item {
      min-width: auto;
    }

    .radio-item,
    .radio-item-unselected {
      width: 100%;
    }

    .radio-item label {
      white-space: normal;
      word-break: break-word;
    }
  }

  /* Extra small devices */
  @media (max-width: 480px) {
    .panel-default {
      padding: 16px 12px;
    }

    .panel-title {
      font-size: 16px;
    }

    .panel-subtitle {
      font-size: 14px;
    }

    .label-names {
      font-size: 16px;
    }

    .note-card-header,
    .note-card-body,
    .note-card-footer,
    .funding-card-header,
    .funding-card-body {
      padding: 10px 12px;
    }

    .note-card-label,
    .note-card-value,
    .funding-card-label,
    .funding-card-value {
      font-size: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// AccountDetail.vue?1a7c27dd